import palette from '../palette';
export default {
  containedPrimary: {
    backgroundColor: palette.background.primary.main,
    '&:hover': {
      backgroundColor: palette.background.primary.ligth,
    },
  },
};
